// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { getDataLayer, getElementsToPushToDataLayer, isInViewport, rcBrand } from "@rc/XDL/Utilities/DataLayer";

export const buildPlpDataLayerEvent = (props: any) => {
    const state = props.getState();
    const currentPage = getCurrentPage(state)?.type;
    const products = props.parameter?.products;
    const selector = props.parameter?.selector;
    const list = props.parameter?.list;

    if (state?.xGA?.productImpressionEvent && getDataLayer() && products?.length) {
        const elements: NodeList = document.querySelectorAll(selector);
        let visibleElements: ProductModel[] = [];

        Array.from(elements).forEach((elem, index) => {
            if (isInViewport(elem)) {
                visibleElements.push(products[index]);
            }
        });

        visibleElements = visibleElements.filter(item => item !== undefined && item !== null);

        const elementsToPush = getElementsToPushToDataLayer(visibleElements);

        if (elementsToPush.length > 0) {
            const GA4Data = {
                event: "US001eComProductImpression",
                ecommerce: {
                    impressions: elementsToPush.map((elem: any) => {
                        if (!elem) {
                            return;
                        }
                        let shortDescription = elem.shortDescription || elem.productTitle || elem.description;
                        shortDescription = shortDescription?.replace(/<(?:.|\n)*?>/gm, '');
                        shortDescription = shortDescription?.replace(/\s+/g, " ").trim();

                        const impression = {
                            id: elem.productNumber,
                            name: shortDescription,
                            price: elem.pricing?.unitNetPrice,
                            brand: rcBrand,
                            list: list || currentPage,
                            quantity: elem.qtyOrdered || elem.minimumOrderQty || 1,
                            lifeStage: "",
                            benefits: "",
                            category: "",
                            variant: "",
                        };

                        if (state["xGA"]["includeProductCategory"]) {
                            impression["lifeStage"] = elem.properties?.lifeStage || "";
                            impression["benefits"] = elem.properties?.benefits || "";
                            impression["category"] = elem.properties?.category || "";
                            impression["variant"] = elem.properties?.variant || "";
                        }

                        return impression;
                    })
                }
            };

            getDataLayer().push(GA4Data);
        }
    }
};

export const chain = [
    buildPlpDataLayerEvent,
];

const buildProductImpressionDatalayer = createHandlerChainRunner(chain, "buildProductImpressionDatalayer");
export default buildProductImpressionDatalayer;
